import { ColorOptions, required } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { Dropdown } from '../../components/Dropdown'

const statusData = [
  { id: 1, value: 'Enable' },
  { id: 2, value: 'Disable' },
]

const textinputStyle = {
  type: 'body14',
  borderColor: '#d1d3e2' as ColorOptions,
  labelPaddingBottom: 8,
  borderRadius: 4,
  labelFontFamily: 'jiotype-bold',
  fontFamily: 'jiotype-medium',
  labelColor: '#6e707e' as ColorOptions,
  labelFontSize: 12,
  fontSize: 14,
  selectionColor: 'BLUE',
  paddingHorizontal: 8,
  color: '#6e707e' as ColorOptions,
  paddingVertical: 8,
  focusBorderColor: '#d1d3e2' as ColorOptions,
  borderWidth: 2,
  onFocusBorderWidth: 2,
}

export const formData: any = (addNetbank: (values: any) => void, entityMap: any) => [
  {
    key: 'entityInfo',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'entityId',
            ComponentName: Dropdown,
            title: 'Entity',
            label: 'Entity',
            validationSchema: required,
            data: entityMap,
          },
          {
            fieldName: 'entityCode',
            ComponentName: TextInputNew,
            label: 'Entity Bank Code',
            placeholder: 'Entity Bank Code',
            validationSchema: required,
            ...textinputStyle,
          },
          {
            fieldName: 'rpslCode',
            ComponentName: TextInputNew,
            label: 'RPSL Bank Code',
            placeholder: 'RPSL Bank Code',
            validationSchema: required,
            ...textinputStyle,
          },
        ],
      },
      {
        horizontalComps: [
          {
            fieldName: 'bankName',
            ComponentName: TextInputNew,
            label: 'Bank Name',
            placeholder: 'Bank Name',
            validationSchema: required,
            ...textinputStyle,
          },
          {
            fieldName: 'status',
            ComponentName: Dropdown,
            title: 'Status',
            label: 'Status',
            validationSchema: required,
            data: statusData,
          },
        ],
      },
    ],
    horizontalFlex: 1,
    onSubmit: async (values: any) => {
      addNetbank(values)
      return 'endPointDetails'
    },
    actionTitle: 'Submit',
  },
]
